import React from 'react';
import UserUpdateManagementPasswordResetSection from './UserUpdateManagementPasswordResetSection';
import UserUpdateManagementEmailVerificationSection from './UserUpdateManagementEmailVerificationSection';
import { CompanyRoleAssignment } from '../../../../../../types/company_role_assignment';

interface UserUpdateManagementPaneProps {
  user: CompanyRoleAssignment;
}

export default function UserUpdateManagementPane({ user }: UserUpdateManagementPaneProps) {
  return (
    <div className='flex-grow overflow-auto'>
      <div className='grid gap-8'>
        <UserUpdateManagementPasswordResetSection user={user} />
        <UserUpdateManagementEmailVerificationSection user={user} />
      </div>
    </div>
  );
}
